<template>
	<section id="create">
	<Notification ref="notif" :closed="true" corner="bottom-right" />
		<form @submit.prevent="saveTipos">
			<Container textButton="voltar" :pathName="{ name: 'tiposList' }" :pathIcone="true">
				<div class="errors">
					<div v-if="submitted && $v.formTipos.nome.$error" class="invalid-feedback">
						<p v-if="!$v.formTipos.nome.required">O nome do tipo é obrigatório</p>
					</div>
					<div v-if="submitted && $v.formTipos.codigo.$error" class="invalid-feedback">
						<p v-if="!$v.formTipos.codigo.required">O código do tipo é obrigatório</p>
					</div>
					<div v-if="addAttr && $v.formAtributo.tipoEntrada.$error" class="invalid-feedback">
						<p v-if="!$v.formAtributo.tipoEntrada.required">Tipo de entrada é obrigatório</p>
					</div>
					<div v-if="addAttr && $v.formAtributo.nome.$error" class="invalid-feedback">
						<p v-if="!$v.formAtributo.nome.required">O nome do atributo é obrigatório</p>
					</div>
				</div>
				<load-content v-if="loadContent" />
				<div class="form-container" v-if="!loadContent">
					<div class="form-type">
						<div class="field status" style="width: 100%">
							<check-status :id="formTipos.id" :nome="'Status Tipo:'" :checked="formTipos.flagAtivo" @change="updateCheckbox('formTipos', 'flagAtivo')" :disabled="$route.meta.readOnly"></check-status>
						</div>
					</div>
					<div class="box-icon">
						<div :class="[submitted && $v.formTipos.nome.$error && 'is-invalid', 'field name']">
							<input type="text" name="nome" id="nome" v-model.lazy="formTipos.nome" autocomplete="off" maxlength="25" @keyup="(e) => changeNomeTipo(e)" placeholder="Digite o nome do tipo"  :disabled="$route.meta.readOnly"/>
						</div>

						<div class="icon-selection">
							<div class="select-section-input">
								<v-select :options="optionsIcons" closeOnSelect:false label="icone" v-model="formTipos.icone"  placeholder="Selecione o ícone" :disabled="$route.meta.readOnly">
									<template v-slot:option="option">
										<span :class="[option.icone, 'iconList']"></span>
									</template>
								</v-select>
							</div>
							<div class="icon-type">
								<i v-if="formTipos.icone" :class="[formTipos.icone]"></i>
								<i v-if="!formTipos.icone" class="fas fa-ban"></i>
							</div>
						</div>
					</div>
				</div>

				<div class="create" v-if="!loadContent">
					<div class="title">Vínculos</div>

					<div class="form-vinculo">
						<div class="box-select">
							<div class="field questoes">
								<check-status :id="formAtributo.flagAtivo.id" :nome="'Permite o cadastro de questões:'" :checked="formTipos.possuiQuestao" @change="updateCheckbox('formTipos', 'possuiQuestao')" @click="alert('Funciona')" :disabled="$route.meta.readOnly"></check-status>
							</div>

							<div class="field codigo">
								<label>
									<span class="legend">Código de tipo: </span>
									<input type="text" maxlength="2" v-model="formTipos.codigo" placeholder="Digite o código do tipo" :disabled="$route.meta.readOnly"/>
								</label>
							</div>
						</div>
					</div>
				</div>

				<!-- Campos para adicionar atributos personlalizáveis no Tipo -->
				<div class="create" v-if="!loadContent && !$route.meta.readOnly">
					<div class="title"><span class="icone"><i class="fas fa-list-ul"></i></span> Atributo personalizável</div>
					<div class="form-atributo">
						<div class="box-select">
							<div class="field ativo">
								<check-status :id="formAtributo.flagAtivo.id" :nome="'Status Atributo:'" :checked="formAtributo.flagAtivo" @change="updateCheckbox('formAtributo', 'flagAtivo')" @click="alert('Funciona')"></check-status>
							</div>

							<div class="field obrigatorio">
								<check-status :id="formAtributo.obrigatorio.id" :nome="'Recurso Obrigatório:'" :checked="formAtributo.obrigatorio" @change="updateCheckbox('formAtributo', 'obrigatorio')" @click="alert('Funciona')"></check-status>
							</div>

							<div class="field">
								<check-status :id="formAtributo.multiplo.id" :disabled="editAtributo" :nome="'Recurso Múltiplo:'" :checked="formAtributo.multiplo" @change="updateCheckbox('formAtributo', 'multiplo')" @click="alert('Funciona')"></check-status>
							</div>

							<div class="select-section-input" :class="[addAttr && $v.formAtributo.tipoEntrada.$error && 'is-invalid', 'field tipoEntrada']">
								<v-select :options="optionsTiposEntradas" :disabled="editAtributo" label="nome"
									v-model="formAtributo.tipoEntrada"
									placeholder="Selecione atributo"/>
							</div>

							<div :class="[addAttr && $v.formAtributo.nome.$error && 'is-invalid', 'field name']">
								<input
									type="text"
									name="nome"
									id="nome"
									v-model.lazy="formAtributo.nome"
									autocomplete="off"
									placeholder="Digite o nome do atributo"
								/>
							</div>

							<div class="btn-attr" @click="addAtributo" :disabled="loadingAdd">
								<span class="txt-button"> {{!editAtributo ? 'INCLUIR ATRIBUTO' : 'ATUALIZAR ATRIBUTO'}}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Exibição de lista dos atributos personlalizáveis cadastrados no Tipo -->
				<div class="box-items" v-if="!loadContent">
					<div class="atributo-header" v-if="formTipos.propriedades.length>0">
						<div class="nome-item">Nome do Atributo</div>
						<div class="status">Status</div>
						<div class="obrigatorio">Obrigatório</div>
						<div class="multi-item">Multiplo</div>
						<div class="type-item">Tipo do Atributo</div>
						<div class="acoes" v-if="!$route.meta.readOnly">Ações</div>
					</div>
					<div class="box-attr" v-for="atributo in formTipos.propriedades" :key="atributo.id">
						<span class="name-attr">{{ atributo.nome }}</span>
						<div class="field-status">
							<span><item-status :status="atributo.flagAtivo"></item-status></span>
						</div>
						<div class="field-obrigatorio">
							<span><item-status :status="atributo.obrigatorio"></item-status></span>
						</div>
						<div class="field-multi-item">
							<span><item-status :status="atributo.multiplo"></item-status></span>
						</div>
						<div>{{ visualizarNomeEntrada(atributo.tipoEntrada) }}</div>
						<div v-if="!$route.meta.readOnly">
							<div class="field-button">
								<div class="editar" @click="() => editarAtributoTeste(atributo)"><i class="fas fa-pencil-alt"></i></div>
								<button-remove :onClick="() => selectAtributoHandler(atributo)"></button-remove>
							</div>
						</div>
					</div>
					<item-empty :msg="msg" :show="formTipos.propriedades.length === 0"></item-empty>
				</div>

				<!-- Modal para confirmação de exclusão de área de conhecimento -->
				<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
					<template v-slot:body>
						Deseja remover o atributo <i>{{ removeItem.nome }}</i>?
					</template>

					<template v-slot:footer>
						<!-- <button type="button" :onClick="() => addToDelete(removeItem.id)">Remover</button> -->
						<button-submit type="button" :onClick="() => addToDelete(removeItem)" class="xs danger" style="margin-right: 10px;">Confirmar</button-submit>
						<button-submit type="button" :onClick="closeModal" class="xs default">Cancelar</button-submit>
					</template>
				</Modal>

				<!-- Modal para alerta de número caracteres -->
				<Modal v-show="isModalVisibleCaractere" @close="() => this.isModalVisibleCaractere = !this.isModalVisibleCaractere">
					<template v-slot:body>
						O nome do tipo possui um limite 25 caracteres.
					</template>
					<button type="button" @onClick="() => this.isModalVisibleCaractere = false" class="xs default">Cancelar</button>
				</Modal>

			<!-- Final exclusão de área de conhecimento  -->
			</Container>
			<div class="submit-form" v-if="!loadContent && !$route.meta.readOnly">
				<button-submit class="large" type="submit" :disabled="loadingSubmit">
					<load-submit v-if="loadingSubmit"></load-submit>
					<span v-else>SALVAR</span>
				</button-submit>
			</div>
		</form>
	</section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import LoadSubmit from '@/components/shared/LoadSubmit'
import ItemStatus from '@/components/shared/ItemStatus'
import ButtonRemove from '@/components/shared/ButtonRemove'
import Modal from '@/components/shared/Modal'
import { tipos } from '@/services/tipos'
import { atributos } from '@/services/propriedade'
import Container from '@/components/shared/Container'
import ButtonSubmit from '@/components/shared/ButtonAction'
import CheckStatus from '@/components/shared/Status'
import ItemEmpty from '@/components/shared/ItemEmpty'
import { toBase64 } from '@/helpers/toBase64'
import vSelect from 'vue-select'
import LoadContent from '@/components/shared/LoadContent'
import { optionsIcons } from '@/helpers/FontAwesomeIcons'

export default {
	name: 'TiposCreate',
	components: { Container, ButtonSubmit, CheckStatus, Modal, ButtonRemove, ItemStatus, ItemEmpty, LoadSubmit, vSelect, LoadContent },
	data () {
		return {
			loadContent: true,
			path: '',
			show: true,
			msg: 'Não possui atributos cadastrados !',
			optionsTiposEntradas: [{ cod: 'text', nome: 'Campo texto' }, { cod: 'textarea', nome: 'Área de texto' }],
			isModalVisible: false,
			isModalVisibleCaractere: false,
			removeItem: {},
			formTipos: {
				nome: '',
				flagAtivo: true,
				propriedades: [],
				url: '',
				icone: '',
				possuiQuestao: true,
				codigo: ''
			},
			formAtributo: {
				id: '',
				nome: '',
				flagAtivo: true,
				tipoEntrada: '',
				multiplo: true,
				obrigatorio: false
			},
			editAtributo: false,
			submitted: false,
			loadingSubmit: false,
			addAttr: false,
			loadingAdd: false,
			atributosApagar: [],
			optionsIcons
			// optionsIcons: ['fas fa-graduation-cap', 'fas fa-microphone-alt', 'fab fa-youtube', 'fas fa-file-alt ', 'fas fa-image', 'fas fa-gamepad', 'fas fa-link']
		}
	},
	validations () {
		return {
			formTipos: {
				nome: {
					required
				},
				codigo: {
					required
				}
			},
			formAtributo: {
				nome: {
					required
				},
				tipoEntrada: {
					required
				}
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	},
	async created () {
		// Edição de objetos
		if (this.$route.params.id) {
			const tip = await tipos.findById(this.$route.params.id)

			if (tip.status === 200) {
				const { nome, flagAtivo, atributos, url, icone, propriedades, possuiQuestao, codigo } = tip.data

				this.formTipos = {
					...this.formTipos,
					nome,
					flagAtivo,
					atributos,
					url,
					icone,
					propriedades,
					possuiQuestao,
					codigo
				}
				this.loadContent = false
			} else {
				this.loadContent = false
			}
		} else {
			this.loadContent = false
		}
	},
	methods: {
		changeStatus (attr) {
			attr = !attr
			return attr
		},
		selectAtributoHandler (data) {
			this.isModalVisible = true
			this.removeItem = data
		},
		editarAtributoTeste (atributo) {
			const tipoEntrada = this.optionsTiposEntradas.find(option => option.cod === atributo.tipoEntrada)
			this.formAtributo = {
				...this.formAtributo,
				id: atributo.id,
				nome: atributo.nome,
				flagAtivo: atributo.flagAtivo,
				obrigatorio: atributo.obrigatorio,
				tipoEntrada: tipoEntrada ? tipoEntrada.nome : atributo.tipoEntrada,
				multiplo: atributo.multiplo

			}
			this.editAtributo = true
		},
		closeModal () {
			this.isModalVisible = false
		},
		catchMessage (response) {
			window.notificationEM.open('', response.response.data.msg, 'error')
			this.loadingSubmit = false
		},
		async saveTipos () {
			let a = {}
			for (a of this.atributosApagar) {
				this.deleteAtributo(a)
			}

			this.submitted = true
			this.loadingSubmit = true
			this.$v.$touch()
			if (this.$v.formTipos.nome.$invalid) {
				this.loadingSubmit = false
				return
			}

			if (this.$v.formTipos.codigo.$invalid) {
				this.loadingSubmit = false
				return
			}

			if (this.formTipos.flagAtivo) this.formTipos.flagAtivo = 1
			else this.formTipos.flagAtivo = 0

			// Se for a edição de um Tipo
			if (this.$route.params.id) {
				tipos.update(this.$route.params.id, this.formTipos).catch(this.catchMessage)
					.then(res => {
						if (res.status === 200) {
							this.loadingSubmit = false
							return this.$router.push({ name: 'tiposList', params: { alert: 'success', message: `Tipo ${this.formTipos.nome} alterado com sucesso!` } })
						} else {
							this.loadingSubmit = false
							window.notificationEM.open('', 'Ocorreu um erro no cadastro, tente novamente!', 'error')
							return console.log(this.formTipos)
						}
					})
			} else {
				tipos.create(this.formTipos).catch(this.catchMessage)
					.then(res => {
						if (res.status === 200) {
							this.loadingSubmit = false
							return this.$router.push({ name: 'tiposList', params: { alert: 'success', message: `Tipo ${this.formTipos.nome} cadastrado com sucesso!` } })
						} else {
							this.loadingSubmit = false
							window.notificationEM.open('', 'Ocorreu um erro no cadastro, tente novamente!', 'error')
							return console.log(this.formTipos)
						}
					})
			}
		},
		async addAtributo () {
			this.addAttr = true
			this.$v.$touch()
			if (this.$v.formAtributo.nome.$invalid || this.$v.formAtributo.tipoEntrada.$invalid) {
				this.loadingAdd = false
				return
			}

			if (this.formAtributo.flagAtivo) this.formAtributo.flagAtivo = 1
			else this.formAtributo.flagAtivo = 0

			if (this.formAtributo.multiplo) this.formAtributo.multiplo = 1
			else this.formAtributo.multiplo = 0

			this.formAtributo.obrigatorio = this.formAtributo.obrigatorio ? 1 : 0

			this.formAtributo.tipoEntrada = this.formAtributo.tipoEntrada.cod

			// Caso seja edição de atributo personalizável
			if (this.formAtributo.id !== '') {
				const index = this.formTipos.propriedades.findIndex(p => p.id === this.formAtributo.id)
				this.formTipos.propriedades[index] = {
					...this.formTipos.propriedades[index],
					nome: this.formAtributo.nome,
					flagAtivo: this.formAtributo.flagAtivo,
					obrigatorio: this.formAtributo.obrigatorio
				}
			} else {
				this.formTipos.propriedades.push(this.formAtributo)
			}

			this.formAtributo = {
				id: '',
				nome: '',
				flagAtivo: this.formAtributo.flagAtivo,
				obrigatorio: this.formAtributo.obrigatorio,
				multiplo: this.formAtributo.multiplo,
				tipoEntrada: ''
			}
			this.editAtributo = false
			this.show = false
			this.addAttr = false
		},
		changeNomeTipo (e) {
			if (e.target.value.length === 25) {
				this.isModalVisibleCaractere = true
				this.formTipos.nome = e.target.value
			}
		},
		async addToDelete (atributo) {
			try {
				if (atributo.id) {
					await atributos.delete(atributo.id)
					this.formTipos.propriedades = this.formTipos.propriedades.filter(attr => attr.id !== atributo.id)
					if (this.formTipos.propriedades.length === 0) {
						this.show = true
					}
				} else {
					this.formTipos.propriedades = this.formTipos.propriedades.filter(attr => attr.id !== atributo.id)
				}
				window.notificationEM.open('', `Atributo ${atributo.nome} removido com sucesso!`, 'success')
			} catch (e) {
				if (e.response.status === 400) {
					window.notificationEM.open('', `${e.response.data.msg}`, 'error')
				} else {
					window.notificationEM.open('', 'Ocorreu um erro na exclusão, tente novamente!', 'error')
				}
			}
			this.isModalVisible = false
		},
		async deleteAtributo (id) {
			const attr = await atributos.delete(id)
			if (attr.status !== 200) {
				console.log('Não foi possivel remover')
			}
		},
		updateCheckbox (form, field) {
			this[form][field] = !this[form][field]
		},
		visualizarNomeEntrada (cod) {
			cod = this.optionsTiposEntradas.find(o => o.cod === cod)
			return cod.nome
		},
		async uploadFile (e, prop) {
			this.formTipos[prop] = {
				...this.formTipos[prop],
				arquivo: {
					...this.formTipos[prop].arquivo,
					nome: e.target.files[0].name,
					tamanho: e.target.files[0].size,
					tipo: e.target.files[0].type
				},
				base64: await toBase64(e.target.files[0])
			}
		}
	}
}
</script>

<style lang="scss" scoped>
#create {
	color: #4f5c6b;
	.form-container{
		display: flex;
		flex-direction: column;

		.form-type {
			display: grid;
			gap: 10px;
			margin-top: 20px;

			.field-status {
				display:flex;
				max-width: 200px;
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				height: 45px;
				display: flex;
				align-items: center;
				padding: 8px 11px;

				input[type="text"] {
					border: none;
					outline: none;
					background-color: transparent;
					width: 100%;
					font-family: $font-family;
					font-weight: $font-weight-placeholder-bolder;
					font-size: $font-size;
					color: $font-color;

				}
				input::placeholder {
					font-family: $font-family;
					font-weight: $font-weight-placeholder-bolder;
					font-size: $font-size;
					color: $font-color;
				}

				label {
					font-weight: $font-weight-default-bolder;
				}
			}
		}

		.box-icon {
			display: grid;
			grid-template-columns: 5.5fr 5fr;
			align-items: center;
			gap:10px;

			.field {
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				height: 45px;
				display: flex;
				align-items: center;
				padding: 8px 11px;

				input[type="text"] {
					border: none;
					outline: none;
					background-color: transparent;
					width: 100%;
					font-family: $font-family;
					color: $font-color;
					font-size: $font-size;

				}

				input::placeholder {
					font-family: $font-family;
					font-weight: $font-weight-default-bolder;
					color: $font-color;
					font-size: $font-size;
				}

				label {
					font-weight: $font-weight-default-bolder;
				}
			}

			.icon-selection {
				display: grid;
				grid-template-columns: 1fr auto;
				gap: 10px;
			}

			.icon-type {
				display: inline-block;
				background-color: $inputs-color;
				border-radius: 5px;
				height: 45px;
				width: 50px;
				align-items: center;

				i {
					display: flex;
					justify-content: center;
					padding: 10px;
					border: 1px solid;
					font-size: 25px;
					width: 100%;
					border: none;
				}
			}
		}
	}

	.create {
		display: flex;
		flex-direction: column;
		margin-top: 20px;
		border-radius: 5px;
		width: 100%;

		.title {
			padding-bottom: 8px;
			border-bottom: 2px solid #3367D6;
			color: #3367d6;
			text-align: left;
			font-size: 1.125em;

			.icone {
				background-color: #3367D6;
				border-radius: 5px;
				padding: 1px 5px;

				i {
					color:#ffffff;
					font-size: 14px;
				}
			}
		}

		.form-atributo, .form-vinculo {
			display: grid;
			//grid-template-columns: 250px 170px 300px 170px;
			grid-gap: 10px 16px;
			margin-top: 15px;

			.box-select {
				display: grid;
				grid-template-columns: 3fr 3fr 3fr;
				gap:10px;

				.select-section-input {
					height: 45px;
					margin-top: 0px;
				}
			}

			.field {
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				height: 45px;
				display: flex;
				align-items: center;
				padding: 8px 11px;

				&.name {
					display: grid;
					grid-template-columns: auto;
					grid-gap: 0 0;
				}

				input[type="text"] {
					border: none;
					outline: none;
					background-color: transparent;
					width: 100%;
					font-family: $font-family;
					color: $font-color;
					font-size: $font-size;

				}
				input::placeholder {
					font-family: $font-family;
					font-weight: $font-weight-default-bolder;
					color: $font-color;
					font-size: $font-size;
				}

				label {
					font-weight: $font-weight-default-bolder;
				}
			}

			.btn-attr {
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: $main-color;
				border-radius: 5px;
				cursor: pointer;

				.txt-button {
					font-size: $font-size;
					font-weight: $font-weight-default-bolder;
					color: #ffffff;
				}
			}
		}

		.form-vinculo .box-select {
			grid-template-columns: 5.5fr 5fr;

			.codigo label {
				display: flex;
				width: 100%;
				border: none;
				outline: none;
				background-color: transparent;
				font-family: "Roboto",sans-serif;
				color: #4f5c6b;

				span {
					min-width: 120px;
				}

				input {
					margin-left: 10px;
					min-width: 50%;
				}
			}
		}
	}
	.box-items {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 13px;
		width: 100%;

		.atributo-header {
			display: grid;
			grid-template-columns: 2fr 1fr 1fr 1fr 2fr 1fr;
			width:100%;
			max-height: 40px;
			padding: 8px 20px 8px 20px;
			background-color: $main-color;
			color:#ffffff;
			border-radius: 5px;
			margin-bottom: 10px;
			margin-top: 10px;
			font-weight: $font-weight-default-bolder;

		}

		.box-attr{
			display: grid;
			grid-template-columns: 2fr 1fr 1fr 1fr 2fr 1fr;
			width:100%;
			max-height: 40px;
			padding: 8px 20px 8px 20px;
			background-color: #f3f7fc;
			border-radius: 5px;
			margin-bottom: 10px;

			.field-button {
				display: flex;
				.editar {
					background: #3367D6 0% 0% no-repeat padding-box;
					border-radius: 5px;
					border: none;
					color: #fff;
					width: 28px;
					height: 28px;
					text-align: center;
					font-size: 13px;
					cursor: pointer;
					margin-right: 7px;
				}
			}
		}
	}
	.submit {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}
}
.form-image {
	margin-top: 10px;
	display: grid;
	input {
		display: block;
	}
	img {
		margin-top: 10px;
		height: 375px;
		width: 750px;
	}
	.fas {
		width: 20px;
		height: 20px;
	}
	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #bd362f;
		margin-top: 10px;
		width: 140px;
		color: #fff;
		cursor: pointer;
	}
}
.is-invalid, .is_invalid {
	border: 1px solid tomato;
}

.select-photo {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-color: #f3f7fc;
	border-radius: 5px;
	height: 350px;
	input{
		display: none;
	}
	img{
		max-width: 250px;
	}

	.photo-frame {
		width: 150px;
		height: 150px;
		border-radius: 100%;
		background: $main-color;
		display: flex;
		align-items: center;
		justify-content: center;
		.icone-galeria {
			color: #fff;
			cursor: pointer;
		}
	}

	.elemento-acao{
		color: $main-color;
		font-size: .9em;
		margin-top: 10px;
		font-weight: $font-weight-default-bolder;
		cursor: pointer;
	}

	.selecione {
		margin-top: 30px;
		border: 1.5px solid#3367d6;
		padding: 5px 20px;
		border-radius: 10px;
	}

	.excluir{
		border: none;
		background-color: #f3f7fc;
	}
}
.iconList {
	display: flex;
	justify-content: center;
	font-size: 30px;
	margin-bottom: 5px;
	align-content: center;
}
</style>

<style lang="scss">
	@media all and (max-width: 1000px) {
		.box-select {
			.form-vinculo & {
				grid-template-columns: 1fr !important;
			}

			.form-atributo & {
				grid-template-columns: 1fr 1fr !important;
			}

			label > span:not(.box) {
				display: inline-block;
				min-width: 180px;
			}

			.vazio {
				display: none;
			}

			.btn-attr {
				grid-column: 1 / -1;
				height: 45px;
			}
		}

		#create .box-items {
			.atributo-header, .box-attr {
				max-height: unset !important;
				align-items: center;
				gap: 10px;
				font-size: .78em;
			}
		}
	}
</style>
